import { render, staticRenderFns } from "./MigrateToV2Popup.vue?vue&type=template&id=f8c427aa&scoped=true&"
import script from "./MigrateToV2Popup.vue?vue&type=script&lang=ts&"
export * from "./MigrateToV2Popup.vue?vue&type=script&lang=ts&"
import style0 from "./MigrateToV2Popup.vue?vue&type=style&index=0&id=f8c427aa&scoped=true&lang=scss&"
import style1 from "./MigrateToV2Popup.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c427aa",
  null
  
)

export default component.exports